import type { Item } from "../common";

export enum OnDemandDecksFilterField {
    TOPIC = "TOPIC",
    LANGUAGE = "ON_DEMAND_LANGUAGE",
}

export type OnDemandDecksFilterFieldSelections = {
    [key in OnDemandDecksFilterField]: Item[];
};
export type OnDemandDecksFilterOptions = {
    [key in OnDemandDecksFilterField]: Item[];
};
